:host {
  @apply relative block h-0;
}

::slotted([slot=icon-link-item]) {
  @apply pb-[10px];
}

::slotted([slot=social-icon]) {
  @apply text-grey;
  fill: currentcolor;
}

::slotted([slot=social-icon]:hover) {
  @apply text-berry;
}
